import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import modalUtils from '../../qti/utils/ModalUtils';
import stringUtils from '../../qti/utils/StringUtils';

const DefaultModal = (props) => {
    const {
        isOpen,
        children,
        onAfterClose,
        onRequestClose,
        shouldCloseOnEsc,
        shouldCloseOnOverlayClick,
    } = props;

    const modalId = stringUtils.getUID();

    const selectParent = () => {
        return document.getElementById('app');
    };

    return (<Modal
        ariaHideApp={false}
        isOpen={isOpen}
        onAfterClose={onAfterClose}
        onRequestClose={onRequestClose}
        parentSelector={selectParent}
        role="dialog"
        shouldCloseOnEsc={shouldCloseOnEsc}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        style={modalUtils.confirmationModalStyles}
        tabindex="0"
        aria={{ describedby: modalId }}
    >
        <div id={modalId}>
            {children}
        </div>
    </Modal>);
};

DefaultModal.propTypes = {
    isOpen: PropTypes.bool,
    children: PropTypes.object.isRequired,
    onAfterClose: PropTypes.func,
    onRequestClose: PropTypes.func,
    shouldCloseOnEsc: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
};

DefaultModal.defaultProps = {
    isOpen: false,
    onAfterClose: null,
    onRequestClose: null,
    shouldCloseOnEsc: false,
    shouldCloseOnOverlayClick: false,
};

export default DefaultModal;
